<!--suppress JSUnresolvedVariable -->
<template>
    <div class="col-12">
        <!-- Navbar Start -->
        <nav class="navbar navbar-light bg-light justify-content-between fixed-top col-lg-4 offset-lg-4">
            <span class="navbar-brand mb-0 ml-22">
                <a :href="bookingUrl">
                    <i class="fa fa-arrow-left text-black"></i>
                </a>
                &nbsp;
                Select available time
            </span>
            <a v-show="!loading" @click.prevent="submit" class="navbar-brand mb-0 ml-22" id="submit-button">
                DONE
            </a>
            <a v-show="loading" class="navbar-brand mb-0 ml-22 disabled">
                <i class="fa fa-solid fa-spinner fa-spin"></i>
            </a>
        </nav>
        <!-- Navbar Ends -->

        <!-- Form Starts -->
        <form>

            <!-- Filter Button Starts -->
            <div class="dropdown mt-60" v-if="showContractor">
                <button id="filter_button" class="btn btn-outline-secondary dropdown-toggle"
                        type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fa fa-filter"></i>
                    Filter By: {{ sortBy }}
                </button>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" @click="sortByDate" href="#">Date</a></li>
                    <li><a class="dropdown-item" @click="sortByFieldworker" href="#">{{ fieldworkerLabel }}</a></li>
                </ul>
            </div>
            <!-- Filter Button Ends -->

            <!-- Note : In case of fieldworkers is hidden add a separator -->
            <!-- Separator Starts -->
            <div v-else class="mt-80"></div>
            <!-- Separator Ends -->

            <!-- Form in case of sort by date Starts -->
            <form id="byDate" v-show="sortBy === 'Date'" class="row">
                <!-- Suggestions Start -->
                <div class="md-20 border-bottom pb-10" v-for="(currentSuggestion,date) of suggestions" :key="date"
                     ref="suggestions">
                    <!-- Suggestion Radio Button Starts -->
                    <div class="form-check">
                        <label class="form-check-label">
                            <input class="form-check-input" name="date" type="radio" v-model="suggestion"
                                   v-if="isEarliestStartTimeIsTheSameAsStartTime(currentSuggestion[0])"
                                   :value="currentSuggestion">
                            <input class="form-check-input" name="date" type="radio" v-model="suggestion" v-else
                                   data-bs-toggle="modal" data-bs-target="#setAppointmentTime"
                                   :value="currentSuggestion">
                            <span class=font-weight-500>
                                {{
                                    getTimeValueInMoment(date, 'ddd, MMMM DD, YYYY hh:mm A')
                                        .format('ddd, MMMM DD, YYYY')
                                }}
                            </span>
                        </label>
                    </div>
                    <!-- Suggestion Radio Button Ends -->

                    <!-- Date and Time Section Starts -->
                    <section class="row date_and_time">
                        <div class="col-6">
                            <p>
                                <span class="text text-muted font-size-13"
                                      v-if="isEarliestStartTimeIsTheSameAsStartTime(currentSuggestion[0])">
                                    Start time
                                </span>
                                <span class="text text-muted font-size-13" v-else>
                                    Earliest available time
                                </span><br/>
                                {{ formatToTime(currentSuggestion[0].from) }}
                            </p>
                        </div>
                        <div class="col-6">
                            <p>
                                <span class="text text-muted font-size-13">Finish time</span><br/>
                                {{
                                    formatToMoment(currentSuggestion[0].from)
                                        .add(duration, 'minutes').format('hh:mm A')
                                }}
                            </p>
                        </div>
                        <div class="col-6" v-if="!isEarliestStartTimeIsTheSameAsStartTime(currentSuggestion[0])">
                            <p>
                                <span class="text text-muted font-size-13">Latest available time</span><br/>
                                {{ formatToTime(currentSuggestion[0].to) }}
                            </p>
                        </div>
                        <div class="col-6" v-if="!isEarliestStartTimeIsTheSameAsStartTime(currentSuggestion[0])">
                            <p>
                                <span class="text text-muted font-size-13">Finish time</span><br/>
                                {{
                                    formatToMoment(currentSuggestion[0].to)
                                        .add(duration, 'minutes').format('hh:mm A')
                                }}
                            </p>
                        </div>
                    </section>
                    <!-- Date and Time Section Ends -->


                    <!-- Fieldworkers Section Starts -->
                    <section class="row fieldworkers" v-show="showContractor">
                        <p>
                            <span class="text text-muted font-size-13">{{ fieldworkerLabel }} available</span><br/>
                        </p>
                        <div class="col-12 read-more">
                            <div class="form-check" v-for="(slot,fieldworker) of groupByFieldworker(currentSuggestion)"
                                 :key="slot[0].id">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" v-model="selectedFieldWorkers"
                                           :data-current-suggestion="currentSuggestion[0].id"
                                           name="selectedFieldWorkers"
                                           :value="{id:slot[0].id,fieldworker_id:slot[0].fieldworker_id}">
                                    {{ fieldworker }}
                                </label>
                                <a :href="slot[0].profile_url">
                                    <img :src="slot[0].avatar_url" class="img rounded-circle img-avatar" width="25"/>
                                </a>
                            </div>
                        </div>
                        <div class="col-11 text-center" @click="seeMoreAndLess($event)"
                             v-show="currentSuggestion && currentSuggestion.length > perPage">
                            <span class="text-muted font-size-13 toggle-length"> 
                                <i class="fa fa-caret-down"></i> Load More
                            </span>
                        </div>
                    </section>
                    <!-- Fieldworkers Section Ends -->
                </div>
                <!-- Suggestions Ends -->
            </form>
            <!-- Form in case of sort by date Ends -->

            <!-- Form in case of sort by fieldworkers Starts -->
            <form id="byFieldworker" v-show="sortBy !== 'Date'" class="row">
                <!-- Fieldworkers Section Starts -->
                <section class="form-check border-bottom md-10" v-for="(availableTimes,username) of fieldworkers"
                         :key="username">
                    <div class="ml-15">

                        <!-- Fieldworker Radio Button Starts -->
                        <label class="form-check-label col-12 parent-radios-label">
                            <input class="form-check-input parent-radios d-none" name="fieldworker" type="radio"
                                   :value="[{id:availableTimes[0].id,fieldworker_id: availableTimes[0].fieldworker_id}]"
                                   v-model="selectedFieldWorkers">
                            {{ username }}

                            <a :href="availableTimes[0].profile_url">
                                <img :src="availableTimes[0].avatar_url" class="img rounded-circle img-avatar img-right"
                                     width="25"/>
                            </a>
                        </label>
                        <!-- Fieldworker Radio Button Ends -->

                        <!-- Suggestions Starts -->
                        <div class="row available-time mt-10" v-for="(currentSuggestion,index) of availableTimes"
                             :key="index" ref="fieldworkers" @click="assignSelectedFieldWorker([currentSuggestion])">
                            <div class="form-check">

                                <!-- Date and Time Radio Button Starts -->
                                <label>
                                    <input class="form-check-input child-radios" type="radio"
                                           v-if="isEarliestStartTimeIsTheSameAsStartTime(currentSuggestion)"
                                           v-model="suggestion" :value="[currentSuggestion]">
                                    <input class="form-check-input child-radios" type="radio" v-else
                                           v-model="suggestion" :value="[currentSuggestion]" data-bs-toggle="modal"
                                           data-bs-target="#setAppointmentTime">
                                    <span class="font-weight-500">
                                        {{ formatToMoment(currentSuggestion.from).format('ddd, MMMM DD, YYYY') }}
                                    </span>
                                </label>
                                <!-- Date and Time Radio Button Ends -->
                                <br>
                                <!-- Date and Time Label Starts -->
                                <label class="form-check-label col-12">
                                    <span class="row">
                                        <div class="row">
                                            <div class="col-6">
                                                <p>
                                                    <span
                                                        v-if="!isEarliestStartTimeIsTheSameAsStartTime(currentSuggestion)"
                                                        class="text text-muted font-size-13">Earliest available time</span>
                                                    <span v-else class="text text-muted font-size-13">Start time</span>
                                                    <br/>
                                                    {{ formatToTime(currentSuggestion.from) }}
                                                </p>
                                            </div>
                                            <div class="col-6">
                                                <p>
                                                    <span
                                                        class="text text-muted font-size-13">Finish time</span><br/>
                                                    {{
                                                        formatToMoment(currentSuggestion.from)
                                                            .add(duration, 'minutes').format('hh:mm A')
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="row"
                                             v-if="!isEarliestStartTimeIsTheSameAsStartTime(currentSuggestion)">
                                            <div class="col-6">
                                                <p>
                                                    <span
                                                        class="text text-muted font-size-13">Latest available time</span><br/>
                                                    {{ formatToTime(currentSuggestion.to) }}
                                                </p>
                                            </div>
            
                                            <div class="col-6">
                                                <p>
                                                    <span
                                                        class="text text-muted font-size-13">Finish time</span><br/>
                                                    {{
                                                        formatToMoment(currentSuggestion.to)
                                                            .add(duration, 'minutes').format('hh:mm A')
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                    </span>
                                </label>
                                <!-- Date and Time Label Ends -->
                            </div>
                        </div>
                        <!-- Suggestions Ends -->

                    </div>
                </section>
                <!-- Fieldworkers Section Ends -->
            </form>
            <!-- Form in case of sort by fieldworkers Ends -->
        </form>
        <!-- Form Ends -->


        <!-- Modal Starts -->
        <div class="modal fade" id="setAppointmentTime" tabindex="-1" aria-labelledby="setAppointmentTimeLabel"
             aria-hidden="true"
             ref="modal" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="setAppointmentTimeLabel">Set appointment time</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body">
                        <p>Please confirm your most suitable time for your booking</p>
                        <p><span class="text font-size-13 text-muted">Booking duration</span> {{ durationString }}
                            <br/>
                            <b>{{ selectedDate }}</b></p>
                        <p class="text text-danger font-size-13" v-if="!timeValidated">Invalid Time : outside the
                            duration</p>
                        <p v-if="suggestion && suggestion.length > 0">
                            <br>
                            <span class="font-weight-500">
                                {{ formatToMoment(suggestion[0].from).format('ddd, MMMM DD, YYYY') }}
                            </span>
                        </p>
                        <!-- Form Start -->
                        <form class="row">
                            <!-- Start Time Input Starts -->
                            <div class="col-6">
                                <label for="from" class="text font-size-13 text-muted">Start time</label>
                                <div class="input-group">
                                    <span class="input-group-text" id="basic-addon1"><i
                                        class="fa fa-clock"></i></span>
                                    <input type="text" class="form-control datetimepicker-input" ref="from" name="from"
                                           id="from"
                                           @change="fromTimeChanged"
                                           v-model="fromTime"/>
                                </div>
                            </div>
                            <!-- Start Time Input Ends -->

                            <!-- End Time Input Starts -->
                            <div class="col-6">
                                <label for="to" class="text font-size-13 text-muted">Finish time</label>
                                <div class="input-group">
                                    <span class="input-group-text" id="basic-addon1"><i
                                        class="fa fa-clock"></i></span>
                                    <input type="text" class="form-control time-picker disabled" disabled
                                           v-model="toTime"
                                           name="to" id="to"/>
                                </div>
                            </div>
                            <!-- End Time Input Ends -->

                        </form>
                        <!-- Form Ends -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="selectTime">Continue</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Ends -->
    </div>
</template>

<script>

import {getSuggestedAvailability, setAppointmentTime} from '@/modules/CustomerPortal/api/availability'
import _ from 'underscore'
import moment from 'moment'

export default {
    name: "AvailableTimePicker",
    data() {
        return {
            perPage: 3,
            toTime: null,
            sortBy: 'Date',
            fromTime: null,
            loading: false,
            suggestions: [],
            fieldworkers: [],
            suggestion: null,
            bookingUrl: null,
            availableTimes: [],
            timeValidated: true,
            showContractor: null,
            datetimepicker: null,
            bookingDuration: null,
            fieldworkerLabel: null,
            selectedFieldWorkers: [],
            selectedFieldWorker: null,
            atLeastOneFieldWorkerSelected: true
        }
    },
    props: {
        bookingId: String,
        customerId: String
    },
    computed: {
        /**
         * @description Get Selected Date from suggestion
         * @returns {string}
         */
        selectedDate() {
            for (let date in this.suggestions) {
                for (let row of this.suggestions[date]) {
                    if (row.id === this.suggestion)
                        return date
                }
            }
        },
        /**
         * @description Get Service Duration in minutes
         * @returns {number}
         */
        duration() {
            return Math.floor(this.bookingDuration * 60);
        },
        /**
         * @description Get duration human string
         * @returns {string}
         */
        durationString() {
            let minutes = this.bookingDuration * 60;
            let hours = Math.floor(minutes / 60)
            minutes = Math.floor(minutes % 60)

            let string = ""

            if (hours === 1)
                string = `${hours} hour`
            else if (hours > 1)
                string = `${hours} hours`

            if (minutes)
                string += ` and `

            if (minutes === 1)
                string += `${minutes} minute`
            else if (minutes > 1)
                string += `${minutes} minutes`

            return string
        },
        /**
         * Check if all form fields is validated
         * @returns {null}
         */
        formValidated() {
            return this.atLeastOneFieldWorkerSelected && this.timeValidated && this.suggestion
        }
    },
    methods: {
        /**
         * @description Check if Object is Iterable
         * @param obj
         * @returns {boolean}
         */
        isIterable(obj) {
            // checks for null and undefined
            if (obj == null) {
                return false;
            }
            return typeof obj[Symbol.iterator] === 'function';
        },
        /**
         * @description Switch Date or Time to Moment Object With Format
         * @param time
         * @returns {moment.Moment}
         */
        getTimeValueInMoment(time, format) {
            return moment(time, [format])
        },
        /**
         * @description Sort Suggestions By Date
         */
        sortByDate() {
            this.sortBy = 'Date'
        },
        /**
         * @description Sort Suggestions By Fieldworkers
         */
        sortByFieldworker() {
            this.sortBy = this.fieldworkerLabel
        },
        /**
         * @description format datetime to 12 hours format
         * @param datetime
         * @returns {string}
         */
        formatToTime(datetime) {
            return moment(datetime).format('h:mm A')
        },
        /**
         * @description convert datetime object to moment.js object
         * @param datetime
         * @returns {moment.Moment}
         */
        formatToMoment(datetime) {
            return moment(datetime);
        },
        /**
         * @description Group Suggestions by Fieldworker username
         * @param data
         * @returns {*}
         */
        groupByFieldworker(data) {
            return _.groupBy(data, function (row) {
                return row.username
            })
        },
        /**
         * @description handle if from time changed to add service duration to from time to get end time
         * @returns {boolean}
         */
        fromTimeChanged() {
            this.fromTime = this.$refs['from'].value
            let selectedFrom = moment(this.fromTime, ['hh:mm A'])
            let validated = false;

            // Loop on all suggestions
            for (let suggestion of this.suggestion) {

                let fromDateTime = moment(suggestion.from)
                let toDateTime = moment(suggestion.to)

                let from = moment(fromDateTime.format('hh:mm A'), ['hh:mm A'])
                let to = moment(toDateTime.format('hh:mm A'), ['hh:mm A'])

                // Validate that the selected interval is after from time and before to time
                if (selectedFrom.isSameOrAfter(from) && selectedFrom.isSameOrBefore(to)) {
                    validated = true
                }

            }

            // update timeValidated component variable
            this.timeValidated = validated

            // returns true if time is valid
            return validated
        },
        /**
         * @description handle select time on modal
         */
        selectTime() {
            // Trigger from time validation if valid continue
            if (this.fromTimeChanged()) {
                $(this.$refs['modal']).modal('toggle')
            }
        },
        /**
         * Assign fieldworker to selected fieldworkers
         * @param value
         */
        assignSelectedFieldWorker(value) {
            this.selectedFieldWorkers = value
        },
        /**
         * @description trigger see more and less
         * @param event
         */
        seeMoreAndLess(event) {
            this.$nextTick(() => {
                let children = $(event.target).closest('.fieldworkers').find('.read-more').children();
                if (this.turn) {
                    $(event.target).closest('.toggle-length').html(`<i class="fa fa-caret-down"></i> Load More`)
                    $(children).slice(this.perPage).css('display', 'none')
                    this.turn = false
                } else {
                    $(event.target).closest('.toggle-length').html(`<i class="fa fa-caret-up"></i> See Less`)
                    $(children).slice(this.perPage).css('display', 'block')
                    this.turn = true
                }
            })
        },
        isEarliestStartTimeIsTheSameAsStartTime(currentSuggestion) {
            return this.formatToMoment(currentSuggestion.from).isSame(this.formatToMoment(currentSuggestion.to))
        },
        /**
         * @description handle submit form
         */
        submit() {


            // Check if inputs are valid
            if (this.formValidated) {
                this.loading = true
                let fieldworkers = this.selectedFieldWorkers.map(row => row.fieldworker_id)
                let date = moment(this.suggestion[0].from).format('YYYY-MM-DD')
                let from = moment(`${date} ${this.fromTime}`, ['YYYY-MM-DD hh:mm A'])
                let to = moment(`${date} ${this.toTime}`, ['YYYY-MM-DD hh:mm A'])
                let bookingId = this.suggestion[0].booking_id
                let customerId = this.customerId
                let companyId = this.companyId

                setAppointmentTime(fieldworkers, from, to, bookingId, customerId, companyId)
                    .then((response) => {
                        if (response.data.redirect_url)
                            window.location.href = response.data.redirect_url
                        else
                            this.loading = false
                    })

            } else {
                // Here we will display an error messaged
                if (!this.atLeastOneFieldWorkerSelected)
                    new window.Toast({
                        message: 'Please select at least one available fieldworkers',
                        type: 'danger',
                        timeout: 1000
                    });
                else if (!this.timeValidated)
                    new window.Toast({
                        message: 'Please select your start time for booking from the fieldworkers available times',
                        type: 'danger',
                        timeout: 1000
                    });
                else if (!this.suggestion)
                    new window.Toast({
                        message: 'Please select a suggestion',
                        type: 'danger',
                        timeout: 1000
                    });
            }
        },
        /**
         * @description Listen to suggestions fields clicks
         */
        listenOnSuggestionClicks(vm) {
            $(this.$refs['suggestions']).each((key, item) => {
                $(item).find('[type="checkbox"]').attr('disabled', true)
                $(item).find('[type="radio"]').on('change', function () {
                    let checkboxes = $('[type="checkbox"]');
                    $(checkboxes).attr('checked', false)
                    $(checkboxes).attr('disabled', true)
                    $(item).find('[type="checkbox"]').attr('disabled', false)
                    if (vm.suggestion) {
                        vm.selectedFieldWorkers = []
                        for (let suggestion of vm.suggestion) {
                            vm.selectedFieldWorkers.push({
                                id: suggestion.id,
                                fieldworker_id: suggestion.fieldworker_id
                            })
                        }
                    }
                })
                $(document).on('change', '[type="radio"]', function () {
                    if (vm.suggestion) {
                        vm.selectedFieldWorkers = []
                        for (let suggestion of vm.suggestion) {
                            vm.selectedFieldWorkers.push({
                                id: suggestion.id,
                                fieldworker_id: suggestion.fieldworker_id
                            })
                        }
                    }
                })
            })
        },
        /**
         * @description Listen to fieldworker's suggestions fields clicks
         */
        listenOnFieldworkersSuggestionClicks() {
            $('.child-radios').on('change', function () {
                $(this).parents('.form-check').find('.parent-radios').prop('checked', true)
                this.selectedFieldWorkers = $(this).parents('.form-check').find('.parent-radios').val()
            })
        },
        /**
         * @description Listen to Load More and Read Less button
         */
        listenToReadMoreReadLessButton(vm) {
            $('.read-more').each(function () {
                let children = $(this).children()
                $(children).slice(vm.perPage).toggle()
            });
        },
        /**
         * @description Initiate datetimepicker
         */
        initiateDatetimePicker() {
            if (!this.datetimepicker) {
                this.datetimepicker = new tempusDominus.TempusDominus(document.getElementById('from'), {
                    display: {
                        components: {
                            calendar: false,
                            date: true,
                            month: false,
                            year: false,
                            decades: false,
                            clock: true,
                            hours: true,
                            minutes: true,
                            seconds: false,
                            useTwentyfourHour: false,
                        },
                        inline: false,
                        theme: 'auto'
                    }
                })
            }
        }
    },
    mounted() {
        // Get Suggestions
        getSuggestedAvailability(this.bookingId, this.customerId).then(response => {
            if (response.data.redirect_url) {
                this.loading = true
                window.location.href = response.data.redirect_url
            }

            this.companyId = response.data.booking.company_id
            this.fieldworkers = response.data.suggestions.sort(item => moment(item.from).unix())
            this.fieldworkerLabel = response.data.labelworkers_name;
            this.showContractor = response.data.show_contractor_name;
            this.bookingDuration = response.data.booking_duration;
            this.bookingUrl = response.data.booking_url

            this.suggestions = _.groupBy(response.data.suggestions, function (row) {
                // Sat, Sep 10, 2022
                return moment(row.from).format('ddd\, MMMM DD\, YYYY hh:mm A')
            });

            this.suggestions = _.object(_.sortBy(_.pairs(this.suggestions), (item) => {
                return moment(item[0], ['ddd\, MMMM DD\, YYYY hh:mm A']).unix()
            }));

            this.fieldworkers = _.groupBy(response.data.suggestions, function (row) {
                return row.username
            });

            // on dom change finish
            this.$nextTick(() => {
                this.listenOnSuggestionClicks(this);
                this.listenOnFieldworkersSuggestionClicks();
                this.listenToReadMoreReadLessButton(this);
            })
        })
    },
    watch: {
        suggestion: function (value) {
            if (value && value.length > 0) {
                this.$refs['from'].value = moment(value[0].from).format('hh:mm A')
                $(this.$refs['from']).attr('value', value[0].from)
                this.fromTime = moment(value[0].from).format('hh:mm A')
                this.fromTimeChanged()
                this.initiateDatetimePicker();
            }
        },
        fromTime: function (value) {
            let time = this.getTimeValueInMoment(value, "h:mm A")
            let minutes = this.bookingDuration * 60;
            this.toTime = time.add(minutes, 'minutes').format('hh:mm A')
        },
        selectedFieldWorkers: function (value) {
            this.atLeastOneFieldWorkerSelected = this.suggestion && value.length > 0;
        }
    }
}
</script>

<style scoped>

#filter_button {
    margin-top: 10px;
    margin-left: 10px;
}

#byDate {
    margin-left: 0;
    margin-top: 20px;
}

#byFieldworker {
    margin-left: 0;
    margin-top: 20px;
}

.fieldworkers {
    margin-left: 10px;
}

.date_and_time {
    margin-left: 10px;
}

.md-10 {
    margin-bottom: 10px;
}

.md-20 {
    margin-bottom: 20px;
}

.ml-22 {
    margin-left: 22px;
}

.mt-10 {
    margin-top: 10px;
}

.font-size-10 {
    font-size: 10px;
}

.font-size-11 {
    font-size: 11px;
}

.font-size-13 {
    font-size: 12px;
}

.font-size-13 {
    font-size: 13px;
}

.container-no-overflow-x {
    overflow-x: hidden;
}


.img-right {
    float: right !important;

}

body {
    overflow-x: hidden !important;
}

.bootstrap-timepicker-widget {
    z-index: 9999 !important;
}

.mt-60 {
    margin-top: 60px;
}

.mt-70 {
    margin-top: 70px;
}

a.disabled {
    /* Make the disabled links grayish*/
    color: gray;
    /* And disable the pointer events */
    pointer-events: none;
}

.img-avatar {
    float: right;
    margin-right: 20px;
    border-radius: 50%;
}

.font-weight-500 {
    font-weight: 500;
}

.mb-10 {
    margin-bottom: 10px !important;
}

.ml-15 {
    margin-left: 15px;
}

.mt-80 {
    margin-top: 80px;
}

.pb-10 {
    padding-bottom: 10px;
}

.parent-radios-label {
    margin-left: -12px;
}
#submit-button{
    cursor: pointer;
}
</style>